import React, { useEffect, useState } from "react";
import AdminSidebar from "./Components/AdminSidebar";
import AdminHeader from "./Components/AdminHeader";
import "./Styles/Index.css";
import DashBoard from "./pages/DashBoard";
import Customers from "./pages/Customers";
import Layout from "./pages/Layout";
import Orders from "./pages/Orders";
import AdminRoute from "../Components/PrivateRoutes/AdminRoute";
import { AdminAllUserFunc } from "../redux/actions/Admin/AdminUser";
import { useDispatch } from "react-redux";
import { AdminAllOrdersFunc } from "../redux/actions/Admin/AdminOrders";
import FeatureEvents from "./pages/FeatureEvents";
import TrendingEvent from "./pages/TrendingEvent";
import CouponCode from "./pages/CouponCode";
import CustomerOrders from "./Components/PagesComponents/Customer/CustomerOrders";
import OrderDetails from "./pages/OrderDetails";
import Profile from "./pages/Profile";
import CommunityEvents from "./pages/CommunityEvents";
import UserCreatedEvents from "./pages/UserCreatedEvents";

function Index() {
  const [active, setActive] = useState(0);
  const [showSidebar, setShowSidebar] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(AdminAllUserFunc());
    dispatch(AdminAllOrdersFunc());
  }, [dispatch]);

  return (
    <AdminRoute>
      <div
        className="relative min-h-screen bg-[#070D1A] text-white z-[1000] max-w-[2000px] mx-auto"
        style={{ fontFamily: "'Outfit', 'Inter', sans-serif" }}
      >
        {showSidebar && (
          <button
            type="button"
            className="fixed inset-0 bg-black/60 z-30 lg:hidden"
            onClick={() => setShowSidebar(false)}
            aria-label="Close menu overlay"
          />
        )}

        <div
          className={
            showSidebar ? "admin-sidebar-wrap admin-sidebar-wrap--open" : "admin-sidebar-wrap"
          }
        >
          <AdminSidebar
            active={active}
            setActive={setActive}
            setShowSidebar={setShowSidebar}
          />
        </div>

        <div className="admin-main ml-0 lg:ml-[200px] min-h-screen">
          <AdminHeader setActive={setActive} setShowSidebar={setShowSidebar} />

          <div className="admin-content pb-[100px] overflow-x-hidden">
            {active === 0 && (
              <DashBoard active={active} setActive={setActive} />
            )}
            {active === 2 && <Customers setActive={setActive} />}
            {active === 3 && <Profile />}
            {active === 5 && <Layout />}
            {active === 1 && <Orders setActive={setActive} />}
            {active === 6 && <FeatureEvents />}
            {active === 7 && <TrendingEvent />}
            {active === 8 && <CouponCode />}
            {active === 9 && <CustomerOrders />}
            {active === 10 && <OrderDetails />}
            {active === 11 && <CommunityEvents />}
            {active === 12 && <UserCreatedEvents />}
          </div>
        </div>
      </div>
    </AdminRoute>
  );
}

export default Index;
